export function getEnvironmentConfig() {
  return {
    apiUrl: import.meta.env.VITE_API_URL || 'https://test-api.rehabilitationhealth.com/api:RIB0KqtX',
    appName: import.meta.env.VITE_APP_NAME || 'ACL Care',
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
  };
}

export const config = getEnvironmentConfig();